import { Component } from '@angular/core';
import { CreateOrganizationComponent } from '../create-organization.component';

@Component({
  selector: 'app-sub-organization',
  standalone: true,
  imports: [CreateOrganizationComponent],
  templateUrl: './sub-organization.component.html',
  styleUrl: './sub-organization.component.scss',
})
export class SubOrganizationComponent {}
